import { render, staticRenderFns } from "./PaymentFailed.vue?vue&type=template&id=e316ab36&scoped=true&"
import script from "./PaymentFailed.vue?vue&type=script&lang=js&"
export * from "./PaymentFailed.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFailed.vue?vue&type=style&index=0&id=e316ab36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e316ab36",
  null
  
)

export default component.exports